import React from 'react';

const Subscribe = ({subData}) => {
    return (
        <form className="js-cm-form"
              id="subForm"
              action="https://www.createsend.com/t/subscribeerror?description="
              method="post"
              data-id="2BE4EF332AA2E32596E38B640E905619DF0F0D58B3943F8C5446D04B7D859A011B60076D529A9444B769A40382500523079723579080C83CEAC0D2824E147CD2"
        >
            <div
                id="subscribe"
                className="items-center
                           mx-6 mb-8 p-4 rounded-xl md:bg-gradient-to-r
                           bg-gradient-to-b from-[#F8CED5_50%] to-[#A8D1FD_90%]">
                <div className="text-center py-4 font-bold md:w-1/2 m-auto">
                    <span className="text-3xl md:text-4xl">{subData.title}</span>
                    <div className="text-sm md:text-lg text-center font-normal">{subData.text}</div>
                </div>
                <div className="md:pb-0 md:pb-4 md:flex justify-center md:w-9/12 m-auto">
                    <div className="md:mr-5 md:w-1/3">
                        <p className="font-semibold">Correo electrónico</p>
                        <div className="flex mt-1">
                            <input type="email"
                                   required="true"
                                   name="cm-jihiuky-jihiuky"
                                   id="fieldEmail"
                                   placeholder="Ingresa tu email"
                                   className="w-full h-10 border-2 border-black mb-2 js-cm-email-input qa-input-email p-2"/>
                        </div>
                    </div>
                    <div className="md:w-2/12">
                        <p className="font-semibold">Fecha de Nacimiento</p>
                        <div className="flex mt-1">
                            <input
                                id="fieldttxjjr"
                                name="cm-f-ttxjjr"
                                type="date"
                                placeholder="Fecha de Nacimiento"
                                className="w-4/6 md:w-full h-10 border-2 border-black mb-2 pointer p-2"
                                required="true"
                            />
                        </div>
                    </div>
                </div>
                <div className="mt-2 flex text-left font-bold md:w-1/2 m-auto">
                    <div>
                        <input
                            id="cm-privacy-consent"
                            name="cm-privacy-consent"
                            style={{accentColor: 'black'}}
                            type="checkbox"
                            required="true"
                        />
                    </div>
                    <div className="pl-2 mb-2 text-[10px] md:text-[13px]">
                        Al enviar este formulario, confirmo que soy residente de Puerto Rico 18+ y acepto los <a
                        href="/transformation/terms-and-conditions" className="border-b border-black" target="_blank">Términos de
                        uso</a>, <a href="/transformation/privacy-policy" className="border-b border-black" target="_blank">Políticas de
                        Privacidad</a> y recibir comunicaciones de marketing y promocionales de L’Óreal
                        Caribe; (2) He leído y reconozco la Política de privacidad y Términos y Condiciones de
                        Transformation por L’Óreal Caribe. L’Óreal Caribe utiliza la información personal que recopila y
                        procesa para proporcionarle contenido, anuncios, ofertas y otras comunicaciones promocionales y
                        de marketing personalizadas (incluidos correos electrónicos promocionales) de Transformation y
                        sus otras marcas, incluso basadas en su perfil de belleza, y para otros fines enumerados en la
                        Política de privacidad de L’Óreal Caribe.
                    </div>
                </div>
                <div className="m-auto w-fit my-3">
                    <button type="submit" className="bg-black text-white px-8 h-10">{subData.text_button}</button>
                </div>
            </div>
        </form>
    );
};

export default Subscribe;
